import PropTypes from "prop-types";
import React, { useEffect } from "react";
import {
  fetchRepository,
  fetchRelatedItem
} from "../../../../redux/actions/repositoryActions";
import { connect, useDispatch } from "react-redux";
import { push } from "connected-react-router";
import RepositoryItemDetails from "./RepositoryItemDetails";
import {
  buildManageRepositoryItemRoute,
  buildShowRepositoryItemVersionRoute
} from "../../../../routes/AdminRoutes";
import { makeGetEntities } from "../../../../redux/selectors/selectors";

const ShowRepositoryItemVersion = ({
  match: {
    params: { repositoryId, itemId, versionId }
  },
  repositoryItem,
  repository
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      fetchRelatedItem(repositoryId, versionId, {
        include: "repository,associated_items,associated_courses"
      })
    );
  }, [itemId]);

  useEffect(() => {
    dispatch(fetchRepository(repositoryId));
  }, [repositoryId]);

  useEffect(() => {
    if (repositoryItem?.isLatestVersion) {
      dispatch(push(buildManageRepositoryItemRoute(repositoryId, versionId)));
    }
  }, [repositoryItem]);

  const handleBackToManageRepositoryItemView = () => {
    dispatch(push(buildManageRepositoryItemRoute(repositoryId, itemId)));
  };

  const handleGoBackHere = () => {
    dispatch(
      push(buildShowRepositoryItemVersionRoute(repositoryId, itemId, versionId))
    );
  };

  if (repositoryItem) {
    return (
      <RepositoryItemDetails
        repositoryItem={repositoryItem}
        repository={repository}
        repositoryId={repositoryId}
        itemId={versionId}
        openedAsVersion={true}
        repositoryAccessType={repositoryItem.repository.accessType}
        onGoBackClick={handleBackToManageRepositoryItemView}
        onReturnHereClick={handleGoBackHere}
      />
    );
  } else {
    return null;
  }
};

const makeMapStateToProps = () => {
  const mapStateToProps = (state, props) => {
    const selector = makeGetEntities();
    const repositoryItem = selector(state.repositoryState, {
      type: "items",
      id: props.match.params.versionId
    });
    const repository = selector(state.repositoryState, {
      type: "libraries",
      id: props.match.params.repositoryId
    });
    return {
      repositoryItem,
      repository
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps, null)(ShowRepositoryItemVersion);

ShowRepositoryItemVersion.propTypes = {
  /**
   * Called to fetch the repository data
   */
  fetchRelatedItem: PropTypes.func,
  location: PropTypes.any,
  match: PropTypes.any,
  push: PropTypes.func,
  /**
   * The current repository containing the displayed item
   */
  repository: PropTypes.object,
  /**
   * The repository item displayed in the page
   */
  repositoryItem: PropTypes.any
};
